import { FormattedMessage, useIntl } from 'react-intl';

import { extractLanguage } from '@/configuration/lang/lang';
import { RIO_MARKETPLACE_MCG_URL } from '@/lib/constants';
import { formatUrl } from '@/lib/utils';

export const StepHeader = () => {
    const intl = useIntl();
    const userLanguage = extractLanguage(intl.locale);

    return (
        <div className='margin-bottom-25 display-flex align-items-center flex-row'>
            <span className='rioglyph rioglyph-chevron-left text-bold' />
            <a className='go-to-landing text-color-black' href={formatUrl(RIO_MARKETPLACE_MCG_URL, userLanguage)}>
                <FormattedMessage id='onboarding.goToLandingPage' />
            </a>
        </div>
    );
};
